/**
 * Shared HITL 3.0 padding token, defined once so the whole hitl_3_0 UI uses one
 * consistent inset and it can be tuned in a single place — the spacing sibling
 * of hitl3Typography's HITL3_FONT_SIZE.
 *
 * It is a CSS length STRING ('8px') on purpose, so it drops into BOTH makeStyles
 * rules (`padding: HITL3_PADDING`) and MUI `sx` (`padding` / `pl` / `px`:
 * HITL3_PADDING) without the number-vs-spacing-multiple ambiguity (in `sx` a
 * number like 8 would mean theme.spacing(8) = 64px, not 8px).
 *
 * IMPORTANT: apply this ONLY behind the hitl_3_0 flag / inside hitl3-only
 * components. The legacy layout keeps its own paddings and must not reference it.
 */
export const HITL3_PADDING = '8px';
